import React from 'react';
import { t, Trans } from '@lingui/macro';
import { Input } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

export const PasswordCheckInfo = {
    title: () => (
        <>
            <ExclamationCircleOutlined
                style={{ color: '#faad14', marginRight: 8, fontSize: 22, position: 'relative', top: 3 }}
            />
        &nbsp;&nbsp;
            <Trans>Password Required</Trans>
        </>
    ),
    onOk: (password, handleOk, action) => {
        if (password) {
            const newAction = {...action};
            newAction.password = password;
            handleOk(newAction);
        }
    },
    width: 416,
    bodyStyle: {},
    okText: <Trans>Confirm</Trans>,
    okButtonProps: { danger: true },
    noPasscode: false,
};

function PasswordCheck(props) {
    // Redux
    const { message, passcode, setPasscode, passcodeRef } = props;

    return (
        <>
            <div style={{marginBottom: 16}}>
                <Trans>
                    Please enter your&nbsp;
                    <b>login password&nbsp;</b>
                    to proceed.
                </Trans>
            </div>
            <Input.Password
                ref={passcodeRef}
                addonBefore={t`Password`}
                value={passcode}
                onChange={e => setPasscode(e.target.value)}
                // onPressEnter={() => PasswordCheckInfo.onOk(passcode, handleOk, action)}
                placeholder="####"
            />
            { message ? <div style={{marginTop: 16, color: "#ff4d4f"}}>{message}</div> : null}
        </>
    );
}

export default PasswordCheck;
